import React, { PropsWithChildren } from 'react';
import { IModalDefault } from './types';
import * as SC from './styles';
import Icon from '../Icon';

const ModalDefault: React.FC<PropsWithChildren<IModalDefault>> = ({
  isOpen,
  title,
  children,
  iconName,
  maxHeight,
  onClose,
  onBack,
}) => {
  return (
    <SC.Overlay isOpen={isOpen} onClick={onClose}>
      <SC.ModalContent
        onClick={(e) => e.stopPropagation()}
        maxHeight={maxHeight}
      >
        <SC.Header>
          <SC.Button onClick={onBack}>
            <Icon iconName="ArrowBackOutlined" htmlColor="#226A43" />
            <SC.TitleGoBack>Voltar</SC.TitleGoBack>
          </SC.Button>
          <SC.Button onClick={onClose}>
            <Icon iconName="CloseOutlined" htmlColor="#226A43" />
          </SC.Button>
        </SC.Header>

        <SC.WrapperTitle>
          {iconName && <Icon iconName={iconName} htmlColor="#226A43" />}
          <SC.Title>{title}</SC.Title>
        </SC.WrapperTitle>
        <SC.WrapperChildren>{children}</SC.WrapperChildren>
      </SC.ModalContent>
    </SC.Overlay>
  );
};

export default ModalDefault;
